import CandlestickChartIcon from "@mui/icons-material/CandlestickChart";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Collapse,
  Divider,
  Grid,
} from "@mui/material";
import { useState } from "react";
import { useLoaderData } from "react-router-dom";
import { toast } from "react-toastify";

import DefaultApiService from "../../../../../infrastructure/api/default";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import DropdownPicker from "../../../../components/shared/dropdown";
import JalaliDatePicker from "../../../../components/shared/jalali-datepicker";

import useCheckPermission from "../../../../common/hooks/useCheckPermission";
import useGetPageInfo from "../../../../common/hooks/useGetPageInfo";
import ReportDataShow from "../../../../components/shared/report/ReportDataShow";
import Selector from "../../../../components/shared/selector";
import {
  filterArrayByArrayId,
  getYesterday,
} from "../../../../middleware/middleware";

const SendGroupSMSPage = () => {
  const pageInfo = useGetPageInfo();
  const dataList = useLoaderData("root");

  const [state, setState] = useState({
    stepList: [],
    gridData: [],
    loading: false,
    table: [],
  });
  const [filterValues, setFilterValues] = useState({
    StepIdList: [],
    DGKind: "Renewable",
    SendSMSKind: "ValidityDate",
    StartDate: getYesterday(),
    EndDate: getYesterday(),
  });
  const [showFilterContainer, setShowFilterContainer] = useState(true);
  const [tableData, setTableData] = useState({
    columns: [],
    data: [],
  });
  const [chartData, setChartData] = useState({
    data: [],
  });

  const onChangeStep = (checked) => {
    setFilterValues((old) => ({
      ...old,
      StepIdList: checked,
    }));

    setState((old) => ({
      ...old,
      stepList: filterArrayByArrayId({
        list: dataList?.StepIdList,
        key: "id",
        ids: checked,
      }),
    }));
  };

  const onChangeLevelKind = (event) => {
    const value = event.target.value;
    setFilterValues((old) => ({
      ...old,
      DGKind: value,
      StepList: [],
    }));

    let substationList = [];
    if (value === "Substation") {
      substationList = dataList?.substationList;
    }

    setState((old) => ({
      ...old,
      stepList: substationList || [],
    }));
  };

  const onClearFilterValues = () => {
    setFilterValues(() => ({
      StepIdList: [],
      DGKind: "City",
      SendSMSKind: "Hourly",
      StartDate: getYesterday(),
      EndDate: getYesterday(),
    }));

    setState((old) => ({
      ...old,
      stepList: [],
    }));
  };

  const onGetReportData = async () => {
    console.log("filterValues", filterValues);
    try {
      setState((old) => ({ ...old, loading: true }));

      const res = await DefaultApiService.postApi(
        "DG/Management/SendGroupSMS/GetData",
        filterValues
      );

      setState((old) => ({ ...old, loading: false }));

      // Make Table Data
      if (res?.data?.tableData) {
        const table = res?.data?.tableData;

        const tableColumns = table.columns.map((x) => ({
          id: x,
          label: x,
        }));
        const tableData = table.data.map((row, index) => {
          let item = {};

          for (let i = 0; i < row.length; i++) {
            item[table.columns[i]] = row[i];
          }
          return item;
        });

        setTableData({
          columns: tableColumns,
          data: tableData,
          title: table?.title,
        });
      }

      // Make Chart Data
      if (res?.data?.chartData) {
        const chart = res?.data?.chartData;
        let finalChartData = [];

        finalChartData = chart.xValues.map((item, index) => ({
          x: item,
          index: index + 1,
        }));

        for (let i = 0; i < chart.data.length; i++) {
          const yData = chart.data[i];
          const sereTitle = chart.seriesTitle[i];

          for (let j = 0; j < yData.length; j++) {
            finalChartData[j][sereTitle] = yData[j];
          }
        }

        setChartData({
          ...chart,
          data: finalChartData,
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "خطایی رخ داده است.");
      setState((old) => ({ ...old, loading: false }));
    }
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title="انرژی ورودی شرکت"
            action={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                <Button
                  variant="outlined"
                  color="warning"
                  startIcon={<SearchIcon />}
                  onClick={onGetReportData}
                  disabled={state.loading}
                >
                  جستجو
                  {state.loading && (
                    <CircularProgress
                      color="warning"
                      size={16}
                      sx={{ ml: 2 }}
                    />
                  )}
                </Button>
                <Divider
                  orientation="vertical"
                  variant="middle"
                  flexItem
                  sx={{ mx: 1 }}
                />
                <Button
                  variant="text"
                  color="gray"
                  startIcon={<HighlightOffIcon />}
                  onClick={onClearFilterValues}
                >
                  حذف فیلترها
                </Button>
                <Divider
                  orientation="vertical"
                  variant="middle"
                  flexItem
                  sx={{ mx: 1 }}
                />
                <Button
                  variant="text"
                  color="primary"
                  startIcon={<CandlestickChartIcon />}
                  onClick={() => {
                    setShowFilterContainer(!showFilterContainer);
                  }}
                >
                  {showFilterContainer ? "پنهان کردن فیلتر" : "نشان دادن فیلتر"}
                </Button>
              </Box>
            }
          />
          <CardContent>
            <Grid container>
              {/* Filter Section */}
              <Grid container item xs={12} md={12} className="filter-bar">
                <Grid item container xs={12} md={12} spacing={2}>
                  <Grid item xs={12} md={4} lg={4}>
                    <DropdownPicker
                      label="به تفکیک"
                      value={filterValues.SendSMSKind}
                      onChange={onChangeLevelKind}
                      list={dataList.DGKind}
                      size="small"
                    />
                  </Grid>

                  <Grid item xs={12} md={4} lg={2}>
                    <DropdownPicker
                      label="بازه زمانی"
                      value={filterValues.SendSMSKind}
                      onChange={(event) => {
                        setFilterValues((old) => ({
                          ...old,
                          SendSMSKind: event.target.value,
                        }));
                      }}
                      list={dataList.SendSMSKind}
                      size="small"
                    />
                  </Grid>

                  <Grid item xs={12} md={4} lg={2}>
                    <DropdownPicker
                      label="واحد"
                      value={filterValues.DivideNumber}
                      onChange={(event) => {
                        setFilterValues((old) => ({
                          ...old,
                          DivideNumber: event.target.value,
                        }));
                      }}
                      list={dataList.divideNumber}
                      size="small"
                    />
                  </Grid>

                  <Grid item xs={12} md={4} lg={2}>
                    <JalaliDatePicker
                      label="از تاریخ"
                      fullWidth
                      value={filterValues.StartDate}
                      onChange={(value) => {
                        setFilterValues((old) => ({
                          ...old,
                          StartDate: value,
                        }));
                      }}
                      size="small"
                    />
                  </Grid>

                  <Grid item xs={12} md={4} lg={2}>
                    <JalaliDatePicker
                      label="تا تاریخ"
                      fullWidth
                      value={filterValues.EndDate}
                      onChange={(value) => {
                        setFilterValues((old) => ({
                          ...old,
                          EndDate: value,
                        }));
                      }}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Collapse
                in={showFilterContainer}
                timeout="auto"
                unmountOnExit
                sx={{ width: "100%" }}
              >
                <Grid container>
                  {/* City */}
                  {filterValues.DGKind !== "Substation" && (
                    <Grid item xs={12} md={6} lg={2}>
                      <Selector
                        title="همه شهرستان‌ها"
                        options={state.stepList}
                        optionName="title"
                        optionValue="id"
                        selectedValues={filterValues.StepIdList}
                        onChange={onChangeStep}
                      />
                    </Grid>
                  )}
                </Grid>
              </Collapse>

              {/* Data */}
              <ReportDataShow
                tableData={tableData}
                chartData={chartData}
                loading={state.loading}
                hasExportPdf={useCheckPermission("pdf")}
                hasExportExcel={useCheckPermission("excel")}
                exportApi={pageInfo.link}
                filterValues={filterValues}
              />
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default SendGroupSMSPage;
